import { Textarea as BaseTextArea, type TextAreaProps } from "@heroui/react";

import { useFieldContext, useLanguage } from "@onesolution/hooks";

export function TextArea(props: TextAreaProps) {
	const field = useFieldContext<string>();
	const { t } = useLanguage();

	return (
		<BaseTextArea
			id={field.name}
			labelPlacement="outside-top"
			name={field.name}
			aria-label="textarea"
			isInvalid={!field.state.meta.isValid}
			value={field.state.value || ""}
			onBlur={field.handleBlur}
			errorMessage={t("message.required")}
			onChange={(e) => field.handleChange(e.target.value)}
			{...props}
		/>
	);
}
